export default __webpack_public_path__ + "static/media/pencilFilled.23a8f8be.svg";